import React from "react"
import { Navigate, useLocation } from "react-router-dom"

const Authmiddleware = ({ children }) => {
  const token = localStorage.getItem("authToken") // Get token from localStorage
  const location = useLocation() // Get current page location

  return token ? children : <Navigate to="/login" state={{ from: location }} />
}

export default Authmiddleware

// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//   const token = localStorage.getItem("authToken"); // Get token from localStorage
//   const location = useLocation(); // Get current page location

//   return token ? children : <Navigate to="/login" state={{ from: location }} />;
// };

// export default PrivateRoute;
